import { Link } from 'react-router-dom';
import styled from 'styled-components';

const Wrap = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing.lg};
  padding: ${({ theme }) => theme.spacing.xl};
  text-align: center;
  background-color: ${({ theme }) => theme.colors.surfaceSoft};
`;

const Code = styled.div`
  font-size: 7.2rem;
  font-weight: 800;
  color: ${({ theme }) => theme.colors.accent};
  letter-spacing: -0.2rem;
  line-height: 1;
`;

const Title = styled.h1`
  font-size: 2.4rem;
  font-weight: 800;
  color: ${({ theme }) => theme.colors.darkSlate};
  margin: 0;
`;

const Body = styled.p`
  font-size: 1.5rem;
  color: ${({ theme }) => theme.colors.slateGrey};
  max-width: 38rem;
  line-height: 1.5;
  margin: 0;
`;

const Actions = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.md};
  flex-wrap: wrap;
  justify-content: center;
  margin-top: ${({ theme }) => theme.spacing.sm};
`;

const PrimaryButton = styled(Link)`
  background-color: ${({ theme }) => theme.colors.accent};
  color: ${({ theme }) => theme.colors.white};
  border-radius: 1rem;
  padding: 1.2rem 2.4rem;
  font-size: 1.4rem;
  font-weight: 700;
  text-decoration: none;
`;

const SecondaryButton = styled.button`
  background-color: transparent;
  color: ${({ theme }) => theme.colors.slate};
  border: 0.1rem solid ${({ theme }) => theme.colors.borderStrong};
  border-radius: 1rem;
  padding: 1.2rem 2.4rem;
  font-size: 1.4rem;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
`;

export default function NotFound() {
  return (
    <Wrap>
      <Code>404</Code>
      <Title>We can't find that page</Title>
      <Body>
        The link may be broken or the page may have moved. If you got here from
        a profile link, double-check it with whoever shared it.
      </Body>
      <Actions>
        <PrimaryButton to="/">Back to home</PrimaryButton>
        <SecondaryButton onClick={() => window.history.back()}>
          Go back
        </SecondaryButton>
      </Actions>
    </Wrap>
  );
}
